/*jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import * as _ from 'underscore';
import { Breakpoint } from 'react-socks';
import EmblaCarousel from 'app/components/common/EmblaCarousel.jsx';
import { AnimatePresence, motion } from 'motion/react';

class PlanDetailBlock extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            
        };

    }

    render() {
        let constants = this.props.app.config.constants,
            mainAction = this.props.startUpgrade,
            mainLabel = '',
            mainButtonClass = 'btn-primary active subscription-button',
            planData = {},
            imageUrl = this.props.app.config.assetsUrl + "/" + this.props.app.config.imageUrl;

        // Starter
        planData[constants.PUB_LEVEL_16] = {
            main: [
                {
                    image: `${imageUrl}/pricing-page/2socials.svg`,
                    title: '2 Social Profiles',
                    copy: 'Connect and manage all your profiles in one place',
                    imageWidth: 115,
                    imageHeight: 115
                },
                {
                    image: `${imageUrl}/pricing-page/50posts.svg`,
                    title: '50 Posts Per Month',
                    copy: 'Starter comes with 50 posts per month for each social',
                    imageWidth: 115,
                    imageHeight: 115
                },
                {
                    image: `${imageUrl}/pricing-page/3socials.svg`,
                    title: '3 Feeds or Sites',
                    copy: 'Auto post from all your favorite sources',
                    imageWidth: 115,
                    imageHeight: 115
                },
            ],
            supplemental: [
                {
                    image: `${imageUrl}/pricing-page/hashtag.svg`,
                    title: 'Smart #Hashtags',
                    copy: 'Increase visibility with AI generated hashtags',
                    imageWidth: 70,
                    imageHeight: 70
                },
                {
                    image: `${imageUrl}/pricing-page/rss.svg`,
                    title: 'Auto Share',
                    copy: 'Auto post from all your favorite sources',
                    imageWidth: 70,
                    imageHeight: 70
                },
                {
                    image: `${imageUrl}/pricing-page/queue.svg`,
                    title: 'Queues',
                    copy: 'Effortlessly schedule months of content',
                    imageWidth: 70,
                    imageHeight: 70
                },
                {
                    image: `${imageUrl}/pricing-page/calendar.svg`,
                    title: 'Calendar',
                    copy: 'Schedule and manage with ease. Plan ahead effortlessly',
                    imageWidth: 70,
                    imageHeight: 70
                },
            ],
            supplementalPitch: 'Join Starter today start saving time with social media automation'
        };

        // Basic
        planData[constants.PUB_LEVEL_15] = {
            main: [
                {
                    image: `${imageUrl}/pricing-page/3socials.svg`,
                    title: '3 Social Profiles',
                    copy: 'Connect and manage all your profiles in one place',
                    imageWidth: 115,
                    imageHeight: 115
                },
                {
                    image: `${imageUrl}/pricing-page/star-pricing.svg`,
                    title: 'Unlimited Posting',
                    copy: 'Unlimited Posting for essential platforms*',
                    imageWidth: 115,
                    imageHeight: 115
                },
                {
                    image: `${imageUrl}/pricing-page/bolt.svg`,
                    title: 'Fast Feed Updates',
                    copy: 'Check feeds every hour for new items to post.',
                    imageWidth: 115,
                    imageHeight: 115
                },
            ],
            supplemental: [
                {
                    image: `${imageUrl}/pricing-page/hashtag.svg`,
                    title: 'Auto #Hashtags',
                    copy: 'Increase visibility with automated hashtags',
                    imageWidth: 70,
                    imageHeight: 70
                },
                {
                    image: `${imageUrl}/pricing-page/rss.svg`,
                    title: '25 Feeds or Sites',
                    copy: 'Auto post from all your favorite sources',
                    imageWidth: 70,
                    imageHeight: 70
                },
                {
                    image: `${imageUrl}/pricing-page/queue.svg`,
                    title: 'Larger Queues',
                    copy: 'Effortlessly schedule months of content',
                    imageWidth: 70,
                    imageHeight: 70
                },
                {
                    image: `${imageUrl}/pricing-page/calendar.svg`,
                    title: 'Calendar',
                    copy: 'Schedule and manage with ease Plan ahead effortlessly',
                    imageWidth: 70,
                    imageHeight: 70
                },
            ],
            supplementalPitch: 'Join Basic today and get access to our most popular tools'
        };

        // Pro
        planData[constants.PUB_LEVEL_6] = {
            main: [
                {
                    image: `${imageUrl}/pricing-page/10socials.svg`,
                    title: '10 Social Profiles',
                    copy: 'Connect and manage all your profiles in one place',
                    imageWidth: 115,
                    imageHeight: 115
                },
                {
                    image: `${imageUrl}/pricing-page/star-pricing.svg`,
                    title: 'Unlimited Posting',
                    copy: 'Unlimited Posting for essential platforms*',
                    imageWidth: 115,
                    imageHeight: 115
                },
                {
                    image: `${imageUrl}/pricing-page/bolt.svg`,
                    title: 'Instant Feed Updates',
                    copy: 'Publish new content to your socials as soon as it goes live',
                    imageWidth: 115,
                    imageHeight: 115
                },
            ],
            supplemental: [
                {
                    image: `${imageUrl}/pricing-page/hashtag.svg`,
                    title: 'Auto #Hashtags',
                    copy: 'Increase visibility with automated hashtags',
                    imageWidth: 70,
                    imageHeight: 70
                },
                {
                    image: `${imageUrl}/pricing-page/rss.svg`,
                    title: '50 Feeds or Sites',
                    copy: 'Auto post from all your favorite sources',
                    imageWidth: 70,
                    imageHeight: 70
                },
                {
                    image: `${imageUrl}/pricing-page/queue.svg`,
                    title: 'Larger Queues',
                    copy: 'Effortlessly schedule months of content',
                    imageWidth: 70,
                    imageHeight: 70
                },
                {
                    image: `${imageUrl}/pricing-page/expand.svg`,
                    title: 'Expandable',
                    copy: 'Add additional socials packages to fit your needs',
                    imageWidth: 70,
                    imageHeight: 70
                },
            ],
            supplementalPitch: 'Join Pro today and get access to our most popular tools'
        };

        // Agency
        planData[constants.PUB_LEVEL_8] = {
            main: [
                {
                    image: `${imageUrl}/pricing-page/250socials.svg`,
                    title: '250 Social Profiles',
                    copy: 'Connect and manage all your profiles in one place',
                    imageWidth: 115,
                    imageHeight: 115
                },
                {
                    image: `${imageUrl}/pricing-page/star-pricing.svg`,
                    title: 'Unlimited Posting',
                    copy: 'Unlimited Posting for essential platforms*',
                    imageWidth: 115,
                    imageHeight: 115
                },
                {
                    image: `${imageUrl}/pricing-page/bolt.svg`,
                    title: 'Instant Feed Updates',
                    copy: 'Publish new content to your socials as soon as it goes live',
                    imageWidth: 115,
                    height: 115
                },
            ],
            supplemental: [
                {
                    image: `${imageUrl}/pricing-page/toolbox.svg`,
                    title: 'Client Portal',
                    copy: 'Post for your customers without managing their logins',
                    imageWidth: 70,
                    height: 70
                },
                {
                    image: `${imageUrl}/pricing-page/teams.svg`,
                    title: 'Teams',
                    copy: 'Collaborate with 2 additional team members',
                    imageWidth: 70,
                    height: 70
                },
                {
                    image: `${imageUrl}/pricing-page/hashtag.svg`,
                    title: 'Smart #Hashtags',
                    copy: 'Increase visibility with AI generated hashtags',
                    imageWidth: 70,
                    height: 70
                },
                {
                    image: `${imageUrl}/pricing-page/rss.svg`,
                    title: '1500 Feeds or Sites',
                    copy: 'Auto post from all your favorite sources',
                    imageWidth: 70,
                    height: 70
                },
            ],
            supplementalPitch: "Join Agency today and get access to the dlvr.it's most powerful tools"
        };

        // Plus
        planData[constants.PUB_LEVEL_9] = {
            main: [
                {
                    image: `${imageUrl}/pricing-page/15socials.svg`,
                    title: '15 Social Profiles',
                    copy: 'Connect and manage all your profiles in one place',
                    imageWidth: 115,
                    imageHeight: 115
                },
                {
                    image: `${imageUrl}/pricing-page/star-pricing.svg`,
                    title: 'Unlimited Posting',
                    copy: 'Unlimited Posting for essential platforms*',
                    imageWidth: 115,
                    imageHeight: 115
                },
                {
                    image: `${imageUrl}/pricing-page/bolt.svg`,
                    title: 'Instant Feed Updates',
                    copy: 'Publish new content to your socials as soon as it goes live',
                    imageWidth: 115,
                    imageHeight: 115
                },
            ],
            supplemental: [
                {
                    image: `${imageUrl}/pricing-page/hashtag.svg`,
                    title: 'Dynamic #Hashtags',
                    copy: 'Auto cycle through a pool of related #hashtags',
                    imageWidth: 70,
                    imageHeight: 70
                },
                {
                    image: `${imageUrl}/pricing-page/everqueue.svg`,
                    title: 'EverQueue',
                    copy: 'Automatically recycle your best social media posts',
                    imageWidth: 70,
                    imageHeight: 70
                },
                {
                    image: `${imageUrl}/pricing-page/queue.svg`,
                    title: 'Extra Large Queues',
                    copy: 'Effortlessly schedule months of content',
                    imageWidth: 70,
                    imageHeight: 70
                },
                {
                    image: `${imageUrl}/pricing-page/rss.svg`,
                    title: '75 Feeds or Sites',
                    copy: 'Auto post from all your favorite sources',
                    imageWidth: 70,
                    imageHeight: 70
                },
            ],
            supplementalPitch: 'Join Plus today and get access to the dlvr.it Power Suite'
        };

        // Agency Plus
        planData[constants.PUB_LEVEL_10] = {
            main: [
                {
                    image: `${imageUrl}/pricing-page/250socials.svg`,
                    title: '250 Social Profiles',
                    copy: 'Connect and manage all your profiles in one place',
                    imageWidth: 115,
                    imageHeight: 115
                },
                {
                    image: `${imageUrl}/pricing-page/star-pricing.svg`,
                    title: 'Unlimited Posting',
                    copy: 'Unlimited Posting for essential platforms*',
                    imageWidth: 115,
                    imageHeight: 115
                },
                {
                    image: `${imageUrl}/pricing-page/bolt.svg`,
                    title: 'Instant Feed Updates',
                    copy: 'Publish new content to your socials as soon as it goes live',
                    imageWidth: 115,
                    imageHeight: 115
                },
            ],
            supplemental: [
                {
                    image: `${imageUrl}/pricing-page/hashtag.svg`,
                    title: 'Dynamic #Hashtags',
                    copy: 'Auto cycle through a pool of related #hashtags',
                    imageWidth: 70,
                    imageHeight: 70
                },
                {
                    image: `${imageUrl}/pricing-page/everqueue.svg`,
                    title: 'EverQueue',
                    copy: 'Automatically recycle your best social media posts',
                    imageWidth: 70,
                    imageHeight: 70
                },
                {
                    image: `${imageUrl}/pricing-page/queue.svg`,
                    title: 'Extra Large Queues',
                    copy: 'Effortlessly schedule months of content',
                    imageWidth: 70,
                    imageHeight: 70
                },
                {
                    image: `${imageUrl}/pricing-page/rss.svg`,
                    title: '1500 Feeds or Sites',
                    copy: 'Auto post from all your favorite sources',
                    imageWidth: 70,
                    imageHeight: 70
                },
            ],
            supplementalPitch: 'Join Agency+ today and get access to the dlvr.it Power Suite'
        };

        if (_.isEmpty(this.props.plans.details[this.props.currentPlan])) {
            return null;
        }

        let displayData = planData[this.props.currentPlan];

        if (this.props.context === 'app' || this.props.context === 'new-subaccount') {
            //mainLabel = `Get ${this.props.plans.details[this.props.currentPlan].label} today`;
            mainLabel = 'Get Started';
        } else {
            mainButtonClass += ' public';
            mainLabel = "Sign Up and Try Pro Free";
            mainAction = this.props.goToSignup;
        }

        let mostPopularLabel = '';
        if (this.props.currentPlan === constants.PUB_LEVEL_6) {
            mostPopularLabel = <span>most popular</span>;
        }

        let annualPrice = <span>${this.props.plans.details[this.props.currentPlan].price[constants.SUBSCRIPTION_TERM_ANNUAL].toFixed(2)} / year</span>,
            discounts = {},
            annualInfo = "Billed annually";
        
        discounts[constants.PUB_LEVEL_6] = {
            price: 99
        };

        if (discounts[this.props.currentPlan]) {
            annualPrice = (
                <span>
                    <span className="discount-price">${discounts[this.props.currentPlan].price} / year</span>
                </span>
            );
            annualInfo = (
                <span className="discount-info">
                    Save 45% - Limited time offer*
                </span>
            );
        }

        let monthlyButtonClass = 'plan-price-button monthly',
            annualButtonClass = 'plan-price-button annual';
        if (this.props.currentTerm === constants.SUBSCRIPTION_TERM_MONTHLY) {
            monthlyButtonClass += ' selected';
        } else if (this.props.currentTerm === constants.SUBSCRIPTION_TERM_ANNUAL) {
            annualButtonClass += ' selected';
        }

        let planChevronLeft = null,
            planChevronRight = null,
            newSubHeaderClass = 'new-sub-header';

        // if ([constants.PUB_LEVEL_15, constants.PUB_LEVEL_6, constants.PUB_LEVEL_9].indexOf(this.props.currentPlan) !== -1) {
        //     planChevronLeft = (
        //         <div className="plan-chevron left" onClick={(e) => {
        //             this.props.changePlanView('prev');
        //         }}>
        //             <i className="icon ion-chevron-left"/>
        //         </div>
        //     );
        //     planChevronRight = (
        //         <div className="plan-chevron right" onClick={(e) => {
        //             this.props.changePlanView('next');
        //         }}>
        //             <i className="icon ion-chevron-right"/>
        //         </div>
        //     );
        //     newSubHeaderClass += ' with-chevrons'
        // }

        return (
            <div className={"new-sub-block"}>
                <div className="most-popular-tag">{mostPopularLabel}</div>
                {this.props.context !== 'new-subaccount' ? (
                    <div className={newSubHeaderClass}>
                        {planChevronLeft}
                        dlvr.it {this.props.plans.details[this.props.currentPlan].label}
                        {planChevronRight}
                    </div>
                ) : null}
                <div className="new-sub-body">
                <AnimatePresence>
                    <motion.div 
                        layout
                        initial={{opacity: 0}}
                        animate={{opacity: 1}}
                        exit={{opacity: 0}}
                        transition={{duration: 0.5, ease: "easeIn"}}>
                        <Breakpoint desktop only>
                            <div className="headline-features">
                                {displayData.main.map((feature, i) => {
                                    return (
                                        <div key={`main-${i}`} className="feature main">
                                            <div className="image-wrapper">
                                                <img src={feature.image} width={feature.imageWidth} height={feature.imageHeight}/>
                                            </div>
                                            <div className="title">
                                                {feature.title}
                                            </div>
                                            <div className="desc">
                                                {feature.copy}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </Breakpoint>
                        <Breakpoint mobile only>
                            <div className="headline-features">
                                <div className="mobile-feature-carousel">
                                    <EmblaCarousel options={{
                                        container: ".mobile-feature-carousel",
                                        slide: ".feature.slide",
                                        align: 'center',
                                        loop: true
                                    }}
                                    extraClasses={this.props.context}>
                                        {displayData.main.map((feature, i) => {
                                            return (
                                                <div key={`main-${i}`} className="feature slide">
                                                    <div className="image-wrapper">
                                                        <img src={feature.image} width={feature.imageWidth} height={feature.imageHeight}/>
                                                    </div>
                                                    <div className="title">
                                                        {feature.title}
                                                    </div>
                                                    <div className="desc">
                                                        {feature.copy}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </EmblaCarousel>
                                </div>
                            </div>
                        </Breakpoint>
                        <div className="price-buttons">
                            <div className={monthlyButtonClass} data-term={constants.SUBSCRIPTION_TERM_MONTHLY} onClick={this.props.updateCurrentPlan}>
                                <div className="price-label">
                                    ${this.props.plans.details[this.props.currentPlan].price[constants.SUBSCRIPTION_TERM_MONTHLY]} / month
                                </div>
                                <div className="price-detail">
                                    Billed monthly
                                </div>
                            </div>
                            <div className={annualButtonClass} data-term={constants.SUBSCRIPTION_TERM_ANNUAL} onClick={this.props.updateCurrentPlan}>
                                <div className="price-label">
                                    {annualPrice}
                                </div>
                                <div className="price-detail">
                                    {annualInfo}
                                </div>
                            </div>
                        </div>
                        <div className="plan-price"></div>
                        <div className="cta-main">
                            <div className={mainButtonClass} onClick={mainAction} role="button" aria-label={mainLabel}>
                                {mainLabel}
                            </div>
                        </div>
                        <div className="supplemental-features">
                            <div className="supplemental-pitch">
                                {displayData.supplementalPitch}
                            </div>
                            <Breakpoint desktop only>
                                <div className="supplemental-features-wrapper">
                                    {displayData.supplemental.map((feature, i) => {
                                        return (
                                            <div key={`supplemental-${i}`} className="feature supplemental">
                                                <div className="image-wrapper">
                                                    <img src={feature.image} width={feature.imageWidth} height={feature.imageHeight}/>
                                                </div>
                                                <div className="title">
                                                    {feature.title}
                                                </div>
                                                <div className="desc">
                                                    {feature.copy}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </Breakpoint>
                            <Breakpoint mobile only>
                                <div className="supplemental-features-wrapper mobile">
                                    {displayData.supplemental.map((feature, i) => {
                                        return (
                                            <div key={`supplemental-${i}`} className="feature supplemental">
                                                <div className="image-wrapper">
                                                    <img src={feature.image} width={feature.imageWidth} height={feature.imageHeight}/>
                                                </div>
                                                <div className="title">
                                                    {feature.title}
                                                </div>
                                                <div className="desc">
                                                    {feature.copy}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </Breakpoint>
                        </div>
                        </motion.div>
                    </AnimatePresence>
                </div>
            </div>
        );
    }
}

PlanDetailBlock.propTypes = {
    context: PropTypes.string,
    plans: PropTypes.object,
    currentPlan: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    currentTerm: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    termButtons: PropTypes.object,
    goToSignup: PropTypes.func,
    startUpgrade: PropTypes.func,
    processing: PropTypes.bool,
    userPerms: PropTypes.object,
    trialEligible: PropTypes.bool,
    addOns: PropTypes.object,
    onAddOnClick: PropTypes.func
};

PlanDetailBlock.defaultProps = {
    context: 'new',
    plans: {},
    currentPlan: 1,
    currentTerm: 1,
    termButtons: null,
    goToSignup: () => {},
    startUpgrade: () => {},
    processing: false,
    userPerms: {},
    trialEligible: false,
    addOns: {
        min: 0,
        qty: 0
    },
    onAddOnClick: () => {}
};

export default PlanDetailBlock;
